import React from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import { useState } from 'react';


function Contact() {
    const [formData, setFormData] = useState({ name: "", email: "", subject: "", message: "" });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSendMessage = () => {
        const { name, email, subject, message } = formData;
        if (!name || !email || !subject || !message) {
            alert("Please fill out all fields before sending a message.");
            return;
        }

        const phoneNumber = "918998100371"; // WhatsApp number (India format)
        const whatsappMessage = `Hello, my name is ${name}.\nEmail: ${email}\nSubject: ${subject}\nMessage: ${message}`;
        const encodedMessage = encodeURIComponent(whatsappMessage);
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

        window.open(whatsappURL, "_blank"); // Open WhatsApp
    };

    return (
        <>
            <Navbar />
            <section id="center" className="center_o pt-5 pb-5 bg_light">
                <div className="container-xl">
                    <div className="row center_o1 text-center">
                        <div className="col-md-12">
                            <h1 className="text-uppercase">Contact</h1>
                            <h6 className="d-inline-block mb-0 col_yell">
                                <a href="#">Home</a> <span className="mx-2 text-muted">/</span>{" "}
                                Contact
                            </h6>
                        </div>
                    </div>
                </div>
            </section>
            <section id="contact" className="p_3">
                <div className="container-xl">
                    <div className="row contact_1">
                        <div className="col-md-6">
                            <div className="contact_1l">
                                <h4 className="col_blue">Got Any Questions?</h4>
                                <h1 className="mt-3">Get In Touch</h1>
                                <p className="mb-0 mt-3">
                                    Irfan Electricals provides quality electrical products and reliable services.
                                </p>
                                <div className="contact_1li row mt-4">
                                    <div className="col-md-6 col-sm-6">
                                        <div className="contact_1lil bg_light rounded_5 p-4">
                                            <h4>
                                                <i className="fa fa-map-marker col_blue fs-1 align-middle me-2" />{" "}
                                                Location
                                            </h4>
                                            <p className="mb-0">IRFAN ELECTRICALS, Office, PLOT NO.200, VIP, MOTI TALAV ROAD, Moti Talav, Bhavnagar, Gujarat, 364006, India</p>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <div className="contact_1lil bg_light rounded_5 p-4">
                                            <h4>
                                                <i className="fa fa-phone col_blue fs-1 align-middle me-2" />{" "}
                                                Phone
                                            </h4>
                                            <p className="mb-0"> +91 9898100371</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="contact_1li row mt-4">
                                    <div className="col-md-6 col-sm-6">
                                        <div className="contact_1lil bg_light rounded_5 p-4">
                                            <h4>
                                                <i className="fa fa-envelope col_blue fs-1 align-middle me-2" />{" "}
                                                Email
                                            </h4>
                                            <p className="mb-0"> info@irfanelectricals.com</p>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <div className="contact_1lil bg_light rounded_5 p-4">
                                            <h4>
                                                <i className="fa fa-clock-o col_blue fs-1 align-middle me-2" />{" "}
                                                Opening
                                            </h4>
                                            <p className="mb-0"> Mon- Sat 9:00 AM - 7:00 PM</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="contact_1r p-4 shadow_box rounded_5">
                                <h6>Name</h6>
                                <input className="form-control" name="name" placeholder="Your Name" type="text" onChange={handleChange} />
                                <h6 className="mt-3">Email</h6>
                                <input className="form-control" name="email" placeholder="info@gmail.com" type="text" onChange={handleChange} />
                                <h6 className="mt-3">Subject</h6>
                                <input className="form-control" name="subject" placeholder="Subject" type="text" onChange={handleChange} />
                                <h6 className="mt-3">Comments / Questions</h6>
                                <textarea name="message" placeholder="Your Message" className="form-control form_text" onChange={handleChange} />
                                <h6 className="mb-0 mt-4 text-uppercase">
                                    <button className="button" onClick={handleSendMessage}>Send Message</button>
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />

        </>
    );
}

export default Contact;
